/* middleware */
/*--------------------------------------------------------------------------------*/
import { cfg } from '../../config';
import { jwtParse } from '../../lib/utility';
import * as cookie from '../../lib/cookie';
import { http } from '../api/http';
import { auth, type UserInfo } from '../api/auth';
const IGNORE: string[] = ['__NOT_FOUND__', 'login', 'logout', 'callback'];
/*--------------------------------------------------------------------------------*/
export type MWParams = {
    path: string;
    ignore?: string[];
    isLine?: boolean;
};
export const authMW = async (params: MWParams) => {
    // Check Ignore
    const ignoreList = params.ignore ?? [];
    const setIgnore = new Set([...IGNORE, ...ignoreList]);
    if (setIgnore.has(params.path)) return;
    // Token Exist Check
    const token = localStorage.getItem(cfg.cookie.TOKEN);
    if (!token) return gotoLogin();
    // Token Expire & Refresh 
    try {
        const { exp } = jwtParse(token) || {};
        if (!exp || Date.now() >= exp * 1000) {
            await http.getRefreshToken(params.isLine);
        }
    } catch {
        return gotoLogin();
    }
    // Session & Profile Management
    const session = sessionStorage.getItem(cfg.cookie.SESSION);
    try {
        let profile: UserInfo;
        if (session) {
            profile = JSON.parse(session) as UserInfo;
        } else {
            const resp = await auth.getUserInfo();
            profile = resp.data as UserInfo;
            sessionStorage.setItem(cfg.cookie.SESSION, JSON.stringify(profile));
        }
        setProfile(profile);
    } catch (err) {
        gotoLogin();
        throw err;
    }
};
/*--------------------------------------------------------------------------------*/
const setProfile = (user: UserInfo) => {
    const pic = 'https://cdn.jsdelivr.net/npm/slimsdk/dist/assets/icon/icon-02.png';
    Object.assign(cfg.user, {
        ...user,
        picture: user.picture || pic,
    });
};
const gotoLogin = () => {
    cookie.clear();
    localStorage.clear();
    sessionStorage.clear();
    if (window.location.pathname !== '/logout') {
        window.location.replace('/logout');
    }
};
/*--------------------------------------------------------------------------------*/
